import React from 'react';
import CaseStatusTrackerItem from './CaseStatusTrackerItem';
import { fnShowNewDashboard } from 'src/helpers/commonFunctions';

const CaseStatusTrackerPres = ({ showPhaseLabel, phases }) => {
  return (
    <div className={fnShowNewDashboard() ? 'new-dashboard-case-tracker case-status-tracker' : 'case-status-tracker'}>
      <div className="progress-bar">
        <ul>
          {phases.map((p, index) => (
            <CaseStatusTrackerItem
              showPhaseLabel={showPhaseLabel}
              title={p.label}
              label={'Step:' + (index + 1) + ': ' + p.label + ', ' + (p.isComplete ? 'completed.' : 'pending.')}
              isCurrent={p.isCurrent}
              isComplete={p.isComplete}
              key={p.label + p.isComplete}
            />
          ))}
        </ul>
      </div>
    </div>
  );
};

export default CaseStatusTrackerPres;
